import { Event } from '@sentry/types'

const redacted = '[redacted]'

export const maskSensitivePathParamForSentry = (url: string) => {
  const urlObj = new URL(url, window.location.origin)
  const pathSegments = urlObj.pathname.split('/')

  const sensitiveWords = [
    'account',
    'account_number',
    'government_id',
    'payment_methods',
  ]

  for (let i = 0; i < pathSegments.length - 1; i++) {
    if (sensitiveWords.includes(pathSegments[i])) {
      pathSegments[i + 1] = redacted
      // eslint-disable-next-line no-plusplus
      i++
    }
  }

  urlObj.pathname = pathSegments.join('/')

  return urlObj.toString()
}

export const maskQueryParamForSentry = (url: string, paramName: string) => {
  const urlObj = new URL(url)
  if (urlObj.searchParams.has(paramName)) {
    urlObj.search = urlObj.search.replace(
      new RegExp(`${paramName}=[^&]*`, 'g'),
      `${paramName}=${redacted}`,
    )
  }

  return urlObj.href
}

export const sanitizeSentryEventData = (event: Event) => {
  const modifiedEvent = JSON.parse(JSON.stringify(event))

  // redact redux store
  if (event?.contexts?.state?.state?.type === 'redux') {
    modifiedEvent.contexts.state.state = redacted
  }

  // redact path params and query params
  if (modifiedEvent?.request?.url) {
    modifiedEvent.request.url = maskSensitivePathParamForSentry(
      modifiedEvent.request.url,
    )
    modifiedEvent.request.url = maskQueryParamForSentry(
      modifiedEvent.request.url,
      'searchQuery',
    )
  }

  // redact exceptions
  if (modifiedEvent?.exception) {
    modifiedEvent.exception = redacted
  }

  // redact tags
  if (modifiedEvent?.tags) {
    modifiedEvent.tags = redacted
  }

  if (
    !modifiedEvent.message &&
    modifiedEvent?.contexts?.error?.['error.code']
  ) {
    modifiedEvent.message = `Error code: ${modifiedEvent?.contexts?.error?.['error.code']}`
  }

  return modifiedEvent
}
